import { render, staticRenderFns } from "./TopTip.vue?vue&type=template&id=3fdfaf5d&scoped=true"
import script from "./TopTip.vue?vue&type=script&lang=js"
export * from "./TopTip.vue?vue&type=script&lang=js"
import style0 from "./TopTip.vue?vue&type=style&index=0&id=3fdfaf5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdfaf5d",
  null
  
)

export default component.exports